
import * as React from 'react'
import { Image, Text, View, TouchableOpacity, Dimensions, ScrollView } from 'react-native'
import images from '../../assets/images'
import { useTheme } from '@react-navigation/native'
import moment from 'moment'
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import { TabView, SceneMap } from 'react-native-tab-view'
import FinanceCumulative from './FinanceCumulative'
import FinanceDate from './FinanceDate'
import FinanceIndex from './FinanceIndex'

const initialLayout = { width: Dimensions.get('window').width };

export default React.memo(function TabFinance({ navigation, route }) {
    const { colors } = useTheme()
    const insets = useSafeAreaInsets()
    const [month_string1, setMonthString1] = React.useState(moment().format('MM/YYYY'))
    const [tripFilter, setTripFilter] = React.useState(3)
    const [tripFilter1, setTripFilter1] = React.useState(3)
    const [day_string, setDayString] = React.useState(moment().format('DD/MM/YYYY'))
    const [month_string2, setMonthString2] = React.useState(moment().format('MM/YYYY'))
    const [index, setIndex] = React.useState(0);
    const [routes] = React.useState([
        { key: 'first', title: 'DT tháng' },
        { key: 'second', title: 'DT ngày' },
        // { key: 'third', title: 'Chỉ số tài chính' },
    ]);
    const renderScene = ({ route }) => {
        switch (route.key) {
            case 'first':
                return <FinanceCumulative month_string={month_string1} tripFilter={tripFilter1} />
            case 'second':
                return <FinanceDate day_string={day_string} tripFilter={tripFilter} />
            // case 'third':
            //     return <FinanceIndex month_string={month_string2} />
        }
    }

    const renderDatePicker = (index) => {
        switch (index) {
            case 0:
                return <TouchableOpacity
                    onPress={() =>
                        navigation.navigate('ModalCalendar', { tab_screen: 'finance', month_string: month_string1, tripFilter: tripFilter1 })}>
                    <Text style={{ color: colors.text, fontFamily: 'Nunito_700Bold', fontSize: 18 }}>{month_string1}</Text>
                </TouchableOpacity>
            case 1:
                return <TouchableOpacity
                    onPress={() =>
                        navigation.navigate('ModalCalendar', { tab_screen: 'finance', day_string: day_string, tripFilter: tripFilter })}>
                    <Text style={{ color: colors.text, fontFamily: 'Nunito_700Bold', fontSize: 18 }}>{day_string}</Text>
                </TouchableOpacity>
            // case 2:
            //     return <TouchableOpacity onPress={() => navigation.navigate('ModalCalendar', { tab_screen: 'finance', month_string: month_string2 })}>
            //         <Text style={{ color: colors.text, fontFamily: 'Nunito_700Bold', fontSize: 18 }}>{month_string2}</Text>
            //     </TouchableOpacity>
            default:
                return null
        }
    }

    React.useEffect(() => {
        if (route.params?.day) {
            switch (index) {
                case 0: setMonthString1(route.params?.day)
                    break
                case 1: setDayString(moment(route.params?.day, 'YYYY-MM-DD').format('DD/MM/YYYY'))
                    break
                // case 2: setMonthString2(route.params?.day)
                //     break
            }
        }

        if (route.params?.filter) {
            console.log('=====', route.params?.filter)
            switch (index) {
                case 0: setTripFilter1(route.params?.filter)
                    break
                case 1: setTripFilter(route.params?.filter)
                    break

            }
        }

    }, [route.params?.day, route.params?.filter])

    return (
        <View style={{ flex: 1 }}>
            <View style={{ paddingHorizontal: 16, marginBottom: 3, paddingTop: insets.top ? insets.top : 14, alignItems: 'center', flexDirection: 'row' }}>
                <Text style={{ color: colors.text, fontFamily: 'Nunito_700Bold', marginLeft: 11, flex: 1, fontSize: 32 }}>Doanh thu</Text>
                {renderDatePicker(index)}
            </View>
            <View style={{ flexDirection: 'row', marginLeft: 22 }}>
                {
                    routes.map((item, idx) => {
                        return <TouchableOpacity style={{
                            borderBottomWidth: 1, borderBottomColor: index !== idx ? 'transparent' : colors.text,
                            marginRight: 24, paddingBottom: 6
                        }} onPress={() => setIndex(idx)} key={idx}>
                            <Text style={{ color: colors.text, fontFamily: index !== idx ? 'Nunito_400Regular' : 'Nunito_700Bold' }}>{item.title}</Text>
                        </TouchableOpacity>
                    })
                }
            </View>
            <TabView
                navigationState={{ index, routes }}
                renderScene={renderScene}
                onIndexChange={setIndex}
                initialLayout={initialLayout}
                renderTabBar={() => null}
            />
        </View>
    );
})